<pcg-resizable-widget>
    <span widget-title>FDA RECALLS</span>
    <div class="h-100" widget-body>
        <p-table
            [value]="recalls()"
            [tableStyle]="{ 'min-width': '100%' }"
            [loading]="loading()"
            [scrollable]="true"
            scrollHeight="flex"
            size="small"
            showLoader="false"
            stripedRows
        >
            <ng-template #header>
                <tr>
                    <th id="recall-number" class="text-nowrap">Recall #</th>
                    <th id="product-description">Product Description</th>
                    <th id="product-ndc">Product NDC's</th>
                    <th id="code-info">Code Info</th>
                    <th id="initiation-date">Date</th>
                </tr>
            </ng-template>
            <ng-template
                #body
                let-row
            >
                <tr>
                    <td class="text-nowrap">
                        <a [href]="'/ndcs/recalls/view/' + row.id">{{ row.recallNumber }}</a>
                    </td>
                    <td>
                        <span
                            [pTooltip]="row.productDescription?.length > 40 ? 'Click recall # to see full detail' : null"
                            tooltipPosition="top"
                            appendTo="body"
                        >
                            {{
                                row.productDescription?.length > 40
                                    ? row.productDescription?.slice(0, 37) + '...'
                                    : row.productDescription
                            }}
                        </span>
                    </td>
                    <td>
                        <span
                            [pTooltip]="row.openFdaProductNdc?.includes(',') ? 'Click recall # to see full detail' : null"
                            tooltipPosition="top"
                            appendTo="body"
                        >
                            {{
                                row.openFdaProductNdc?.includes(',')
                                    ? row.openFdaProductNdc?.substring(0, $safeNavigationMigration(row.openFdaProductNdc?.indexOf(',')))
                                    : row.openFdaProductNdc
                            }}
                        </span>
                    </td>
                    <td>
                        <span
                            [pTooltip]="row.codeInfo?.length > 40 ? 'Click recall # to see full detail' : null"
                            tooltipPosition="top"
                            appendTo="body"
                        >
                            {{ row.codeInfo?.length > 40 ? row.codeInfo?.slice(0, 37) + '...' : row.codeInfo }}
                        </span>
                    </td>
                    <td>{{ row.recallInitiationDateStr }}</td>
                </tr>
            </ng-template>
            <ng-template #emptymessage>
                <tr>
                    <td
                        colspan="5"
                        class="text-center text-muted py-3"
                    >
                        No recalls to display
                    </td>
                </tr>
            </ng-template>
            <ng-template #loadingbody>
                <tr>
                    <td><p-skeleton height="2rem" /></td>
                    <td>
                        <p-skeleton
                            height="2rem"
                            width="100px"
                        />
                    </td>
                    <td>
                        <p-skeleton
                            height="2rem"
                            width="80px"
                        />
                    </td>
                    <td>
                        <p-skeleton
                            height="2rem"
                            width="80px"
                        />
                    </td>
                    <td>
                        <p-skeleton
                            height="2rem"
                            width="60px"
                        />
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
</pcg-resizable-widget>